/**
 * Does this look like an address we could actually send to?
 *
 * A deliberately shallow shape check, not an attempt at RFC 5322 — the only
 * thing that proves an address exists is mail arriving at it. It catches the
 * typo class that matters: a missing `@`, or a domain with no dot (`dale@gmial`
 * rather than `dale@gmail.com`), which is accepted everywhere downstream and
 * then fails silently at the mail server.
 *
 * Shared between web and api on purpose. A hunter's email is how a Stripe
 * invoice link reaches them, and the kiosk is unattended — nobody is at the
 * counter to notice the address was wrong — so the same rule has to hold at the
 * form AND at the public mutation behind it, which any client can call.
 * @param value - The address as typed.
 * @returns true when the shape is plausible; false for empty or malformed.
 */
export function looksLikeEmailAddress(
  value: string | null | undefined,
): boolean {
  const trimmed = value?.trim();
  if (!trimmed) return false;
  // Local part, a single @, then a dotted domain with no whitespace anywhere.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
}
